module.exports = __webpack_public_path__ + "img/ghosttownthumb.96aab436.gif";